<div class="card feedback-dialog">
  <div class="card-header">
    <span class="card-title">Report an incorrect answer</span>
    <button mat-mini-fab class="closex" color="warn" type="button" (click)="dialogRef.close()" matTooltip="Close" aria-label="Close dialog">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div class="card-body feedback-dialog-body">
    <div class="exchange-label">Your question</div>
    <div class="exchange-text">{{ data.question }}</div>

    <div class="exchange-label">Assistant answer</div>
    <div class="exchange-text answer-text" [innerHTML]="data.assistantAnswer"></div>

    <form [formGroup]="feedbackForm" (ngSubmit)="submit()">
      <label class="editor-label">What was incorrect, or what did you expect?</label>
      <quill-editor
        class="assistant-rich-editor"
        formControlName="expectedBehavior"
        [modules]="quillConfig"
        [sanitize]="true"
        placeholder="Describe the problem, paste a screenshot, or show the expected answer…"
      ></quill-editor>
      <div class="editor-error" *ngIf="feedbackForm.get('expectedBehavior')?.touched && feedbackForm.get('expectedBehavior')?.hasError('required')">Please describe the problem.</div>
      <div class="editor-error" *ngIf="feedbackForm.get('expectedBehavior')?.hasError('maxlength')">The report is too large. Remove or reduce an image and try again.</div>

      <div class="dialog-error" *ngIf="error">{{ error }}</div>
      <div class="form-actions">
        <button mat-button type="button" (click)="dialogRef.close()">Cancel</button>
        <button mat-flat-button color="primary" type="submit" [disabled]="submitting">
          <mat-icon>flag</mat-icon>
          {{ submitting ? 'Submitting…' : 'Submit report' }}
        </button>
      </div>
    </form>
  </div>
</div>
